import { render, staticRenderFns } from "./MirCashbackIcon.vue?vue&type=template&id=734dcc54&"
import script from "./MirCashbackIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MirCashbackIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports